@if (platformBrowser) {
  <app-not-found bgChars="404" errorTitle="Not Found">
    This gallery has expired or is no longer accessible.
  </app-not-found>
}
@if (!platformBrowser) {
  <div class="page center tiny loading">
    <app-tenant-icon-loader [tenant]="tenant"></app-tenant-icon-loader>
  </div>
}
